import { render, staticRenderFns } from "./TabletFrame.vue?vue&type=template&id=93c180c4&scoped=true&"
import script from "./TabletFrame.vue?vue&type=script&lang=js&"
export * from "./TabletFrame.vue?vue&type=script&lang=js&"
import style0 from "./TabletFrame.vue?vue&type=style&index=0&id=93c180c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c180c4",
  null
  
)

export default component.exports